import React from 'react'
import NFLTemplate from 'src/components/page/nfl'
import { teamIds } from 'src/constants/personalizationIds'

export default (props) => {
  return (
    <NFLTemplate
      {...props}
      team="San Francisco 49ers"
      teamShort="49ers"
      teamId={teamIds['San Francisco 49ers']}
    />
  )
}
